export const SET_NOTHING = 'SET_NOTHING';